// REF: https://github.com/adobe/aem-spa-page-model-manager/blob/master/src/ModelClient.ts
/* eslint-disable arrow-body-style */
/* eslint-disable no-underscore-dangle */
import React from 'react';
import { render } from 'react-dom';
import { BaseModelClient } from './BaseDevModelClient';
import { Error500 } from './components/Error500';
import { getPreloadedModel, isPreloaded } from './utils/preloader';
function render500ErrorPage(responseJson) {
    const { homeLink, labels, locale, title, isRightToLeft } = responseJson;
    return render(React.createElement(Error500, { labels: labels, title: title, locale: locale, homeLink: homeLink, isRightToLeft: isRightToLeft }), document.getElementById('spa-root'));
}
export default class LocalDevModelClient extends BaseModelClient {
    getURL(modelPath) {
        // Either the API host has been provided or we make an absolute request relative to the current host
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const apihostPrefix = this._apiHost || location.origin;
        const modelPathWithoutHtml = modelPath.replace('.html', '');
        const modelPathWithoutTrailingSlash = modelPathWithoutHtml.replace('/.model.json', '.model.json');
        const url = new URL(`${apihostPrefix}${modelPathWithoutTrailingSlash}`);
        return url;
    }
    isPreloaded(url) {
        return isPreloaded(url.pathname);
    }
    getPreloadedModel(url) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return getPreloadedModel(url.pathname);
    }
    get credentials() {
        return 'include';
    }
    onError(error) {
        if (error && error.response && error.response.status === 500 && 'json' in error.response) {
            error.response.json().then((data) => {
                render500ErrorPage(data);
            });
        }
        return super.onError(error);
    }
}
